import { stashInviteToken } from "./inviteToken";

stashInviteToken();
